export default {
  computed: {
    isLearnerType () {
      return this.$route.path.split('/').indexOf( 'learner-type' ) !== -1;
    },

    isAnimalType () {
      return this.$route.path.split('/').indexOf( 'animal-type' ) !== -1;
    },

    isLeaderboard () {
      return this.$route.path.split('/').indexOf( 'leaderboard' ) !== -1
    }
  },
  
  methods: {
    isSingleEvent() {
      return 'eventId' in this.$route.params && this.$route.params.eventId;
    },

    isFusion () {
      return this.isSingleEvent() && /^fusion.*/.test(this.$route.params.eventId);
    },

    isISTE_2024() {
      return this.isSingleEvent() && this.$route.params.eventId === 'iste-2024';
    }
  }
};
